import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { coursePreview, fetchCourse } from "../../api/courses/students";
import { fetchLessons } from "../../api/lessons/students";
import { signUpForCourse } from "../../api/course_accesses"

import Navbar from "../../components/Navbar";
import { Button } from "../../components/Shared/Button";

import "./index.css";

import previewImgSrc from "../../images/Logo.png";

function BackIcon() {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.7072 13.7929C9.09772 14.1834 9.09772 14.8166 8.7072 15.2071C8.31668 15.5976 7.68351 15.5976 7.29299 15.2071L1.50009 9.41421C0.719046 8.63317 0.719044 7.36684 1.50009 6.58579L7.29299 0.792894C7.68351 0.402369 8.31668 0.402369 8.7072 0.792894C9.09772 1.18342 9.09772 1.81658 8.7072 2.20711L3.91431 7H18.0001C18.5524 7 19.0001 7.44772 19.0001 8C19.0001 8.55229 18.5524 9 18.0001 9H3.91431L8.7072 13.7929Z" fill="#131313"/>
    </svg>
  )
}

function EmployeeCourseOverviewHero({
  title = "",
  author_name = "",
  author_profile_image_url = "",
}) {

  return (
    <div className="EmployeeCourseOverviewHeroContainer">
      <div className="EmployeeCourseOverviewHero">
        <div className="EmployeeCourseOverviewHeroCourseTitle">{title}</div>
        <div className="EmployeeCourseOverviewHeroAuthorInfo">
          <div>
            <div
              style={{ backgroundImage: `url("${author_profile_image_url}")` }}
              className="EmployeeCourseOverviewHeroAuthorImg"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div className="EmployeeCourseOverviewHeroAuthor">
              By {author_name}
            </div>
            <div className="EmployeeCourseOverviewHeroAuthorHeader">Author</div>
          </div>
        </div>
      </div>
    </div>
  )
}

const monthAbbr = [
  "Jan", "Feb", "Mar", "Apr",
  "May", "Jun", "Jul", "Aug",
  "Sep", "Oct", "Nov", "Dec",
];

function EmployeeCourseOverview() {
  const navigate = useNavigate();
  const { courseId } = useParams();
  
  const [courseOverview, setCourseOveriew] = useState({});
  const [lessons, setLessons] = useState([]);

  useEffect(async () => {
    const res = await coursePreview(courseId);
    setCourseOveriew(res);
    setLessons(res.lessons);
  }, []);

  function parseUpdatedDate() {
    const d = new Date(courseOverview.updated_at);
    return `${d.getDate()} ${monthAbbr[d.getMonth()]} ${d.getFullYear()}`;
  }

  function parseVideoURL() {
    if (courseOverview.video_url && courseOverview.video_url.length > 0) {
      let arr = courseOverview.video_url.split("/");
      let src;
      if (arr.length === 5) {
        src = `https://player.vimeo.com/video/${arr[arr.length - 2]}/${arr[arr.length - 1]}`
      } else if (arr.length === 4) {
        src = `https://player.vimeo.com/video/${arr[arr.length - 1]}`;
      }
      return src;
    }
  }

  function getStyle() {
    const { video_url = "", hero_image_url = ""} = courseOverview;
    if ((video_url || "").length === 0 && hero_image_url.length > 0) {
      return (
        {
          backgroundImage: `url("${hero_image_url}")`,
        }
      )
    }

    if (video_url && video_url.length > 0) {
      return { backgroundImage: "none" };
    }

    return {
      backgroundImage: `url(${previewImgSrc})`,
    }
  }

  function renderPreviewContent() {
    const { video_url } = courseOverview;
    return (
      <div
        className="EmployeeCourseOverviewPreviewContent"
        style={getStyle()}
      >
        {video_url && video_url.length > 0 ? 
          <iframe
            src={parseVideoURL() || ""}
            allow="autoplay;fullscreen; picture-in-picture"
            allowfullscreen
            frameborder="0"
          />
          : <></>
        }
      </div>
    )
  }

  return (
    <div className="EmployeeCourseOverviewContainer">
      <Navbar />
      <div className="EmployeeCourseOverviewBackContainer">
        <button onClick={() => navigate(`/employee/dashboard`)}>
          <BackIcon />
          Back
        </button>
      </div>
      <EmployeeCourseOverviewHero {...courseOverview} />
      <div className="EmployeeCourseOverviewDescContainer">
        <div className="EmployeeCourseOverviewDesc">
          <h1>Overview</h1>
          <p>{courseOverview.description}</p>
        </div>
        <div className="EmployeeCourseOverviewPreview">
          {renderPreviewContent()}
          <div className="EmployeeCourseOverviewPreviewItem">
            <div>Lessons</div>
            <div>{lessons && lessons.length}</div>
          </div>
          <div className="EmployeeCourseOverviewPreviewItem">
            <div>Last Updated</div>
            <div>{courseOverview.updated_at && parseUpdatedDate()}</div>
          </div>
          <div className="EmployeeCourseOverviewPreviewEnroll">
            <Button
              block
              text="Get Started"
              onClick={async () =>{
                try {
                  await signUpForCourse({ course_id: courseId });
                  navigate(`/courses/${courseOverview.id}/lessons/${lessons[0].id}`)
                } catch (err) {
                  console.log(err);
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmployeeCourseOverview;
